(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/events/';
  var REVISION = '2024-10-15';

  function field(form, name) {
    var el = form.querySelector('[name="comment[' + name + ']"]');
    return el ? el.value.trim() : '';
  }

  function send(key, metric, payload) {
    var body = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            comment: payload.comment,
            name: payload.name,
            file_name: payload.fileName,
            file_size_kb: payload.fileSizeKb,
            file_type: payload.fileType,
            file_url: payload.fileUrl,
            page_url: window.location.href.split('#')[0],
            page_path: window.location.pathname,
            page_title: document.title,
            template: (document.body.getAttribute('data-hi-template') || '')
          },
          metric: { data: { type: 'metric', attributes: { name: metric } } },
          profile: {
            data: {
              type: 'profile',
              attributes: { email: payload.email, first_name: payload.name }
            }
          }
        }
      }
    };

    return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok && res.status !== 202) throw new Error('klaviyo ' + res.status);
      return res;
    });
  }

  function upload(cloud, preset, file) {
    var body = new FormData();
    body.append('file', file);
    body.append('upload_preset', preset);

    return fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/image/upload', {
      method: 'POST',
      body: body
    })
      .then(function (res) {
        if (!res.ok) throw new Error('upload ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (!json.secure_url) throw new Error('upload missing url');
        return json.secure_url;
      });
  }

  function init(form) {
    if (form.dataset.hiCmBound) return;
    form.dataset.hiCmBound = '1';

    var wrap = form.parentNode;
    var success = wrap.querySelector('[data-hi-cm-success]');
    var error = form.querySelector('[data-hi-cm-error]');
    var button = form.querySelector('.hi-cm-submit');
    var fileInput = form.querySelector('[data-hi-cm-file]');
    var fileNote = form.querySelector('[data-hi-cm-file-note]');
    var idleNote = form.getAttribute('data-file-note') || '';
    var allowed = ['image/png', 'image/jpeg', 'image/webp'];

    function resetFile(message) {
      if (fileInput) fileInput.value = '';
      if (fileNote) {
        fileNote.textContent = message || idleNote;
        fileNote.classList.toggle('hi-cm-file-note--error', !!message);
      }
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var f = fileInput.files && fileInput.files[0];
        if (!f) return resetFile('');

        var maxMb = parseFloat(fileInput.getAttribute('data-max-mb')) || 5;
        if (allowed.indexOf(f.type) === -1) {
          return resetFile(form.getAttribute('data-msg-wrong-type'));
        }
        if (f.size > maxMb * 1024 * 1024) {
          return resetFile((form.getAttribute('data-msg-too-big') || '').replace('{max}', maxMb));
        }
        if (fileNote) {
          fileNote.textContent = f.name;
          fileNote.classList.remove('hi-cm-file-note--error');
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var chosen = fileInput && fileInput.files && fileInput.files[0];
      var payload = {
        name: field(form, 'author'),
        email: field(form, 'email'),
        comment: field(form, 'body'),
        fileName: chosen ? chosen.name : '',
        fileSizeKb: chosen ? Math.round(chosen.size / 1024) : 0,
        fileType: chosen ? chosen.type : ''
      };

      if (error) error.hidden = true;
      form.querySelectorAll('.hi-cm-input').forEach(function (el) {
        el.classList.remove('hi-cm-input--invalid');
      });

      var missing = [];
      if (!payload.name) missing.push('author');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(payload.email)) missing.push('email');
      if (!payload.comment) missing.push('body');

      if (missing.length) {
        missing.forEach(function (n) {
          var el = form.querySelector('[name="comment[' + n + ']"]');
          if (el) el.classList.add('hi-cm-input--invalid');
        });
        var first = form.querySelector('.hi-cm-input--invalid');
        if (first) first.focus();
        return;
      }

      var key = form.getAttribute('data-klaviyo-key');
      var metric = form.getAttribute('data-metric') || 'Submitted Comment';

      if (button) {
        button.disabled = true;
        button.classList.add('hi-cm-submit--busy');
      }

      var done = function () {
        form.hidden = true;
        if (success) {
          success.hidden = false;
          success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      };

      var fail = function () {
        if (button) {
          button.disabled = false;
          button.classList.remove('hi-cm-submit--busy');
        }
        if (error) error.hidden = false;
      };

      var cloud = form.getAttribute('data-upload-cloud');
      var preset = form.getAttribute('data-upload-preset');

      var withFile = Promise.resolve('');
      if (chosen && cloud && preset) {
        if (fileNote) {
          fileNote.textContent = form.getAttribute('data-msg-uploading') || '';
          fileNote.classList.remove('hi-cm-file-note--error');
        }
        withFile = upload(cloud, preset, chosen);
      }

      withFile
        .then(function (url) {
          payload.fileUrl = url;
          if (!key) return done();
          return send(key, metric, payload).then(done);
        })
        .catch(function (err) {
          if (String(err.message).indexOf('upload') === 0) {
            if (fileNote) {
              fileNote.textContent = form.getAttribute('data-msg-upload-failed') || '';
              fileNote.classList.add('hi-cm-file-note--error');
            }
            resetFile(form.getAttribute('data-msg-upload-failed'));
          }
          fail();
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-hi-cm-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
